import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePlacesState = () => React.useContext(Context)
export const usePlaces = () => usePlacesState()?.places

const QUERY = gql`
  query Places($ids: [Integer]) {
    places(filter: { ids: $ids }, sort: { field: NAME, type: ASC }) {
      id
      name
      resume
      type
    }
  }
`

const PlacesLoader = ({ children }) => {
  const { placeIds: ids } = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    skip: !ids?.length,
    variables: { ids },
    client: placesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlacesLoader
